import React from 'react';

import * as CreditActions from '../CreditActions';
import * as ActionConstants from '../../../utils/ActionConstants';
import * as CreditConstants from '../CreditConstants';
import CustomInput from '../../../common/components/CustomInput';
import CustomSelect from '../../../common/components/CustomSelect';
import * as Strings from '../../../utils/strings';
import CreditStore from '../CreditStore';
import { serializeForm, isValid } from '../creditUtils';
import sessionManager from 'utils/managers/sessionManager';

export default class CreditApplicationStep5 extends React.Component {
    next(e) {
        e.preventDefault();
        const form = serializeForm(this.refs);
        const user = sessionManager.getUser();

        const creditForm = Object.assign({}, CreditStore.getState(), {
            ...form
        });

        if (isValid(this.refs) && this.refs['creditCheckConsent'].checked) {
            delete creditForm.state;
            creditForm.creditCheckConsent = true;
            console.log('&&&&&&&&&&&USER', user);
            if (user.role === 'vendor') {
                creditForm.vendorPortalId = user._id;
            } else {
                creditForm.lesseePortalId = user._id;
            }

            CreditActions.sendApplication(creditForm);
        }
    }

    back = e => {
        e.preventDefault();
        const creditApp = CreditStore.getState();
        if (
            creditApp.yearsInBusiness < 3 ||
            creditApp.businessType === 'Proprietorship'
        ) {
            CreditActions.goTo(CreditConstants.CREDIT_STEP4, {});
        } else {
            CreditActions.goTo(CreditConstants.CREDIT_STEP3, {});
        }
    };
    render() {
        return (
            <div className="credit-application-step">
                <form onSubmit={this.next.bind(this)}>
                    <div
                        className="form-container"
                        style={{ textAlign: 'left' }}
                    >
                        <div>
                            <p>
                                We almost finished!! Now we will require you to
                                read over the information below and give us
                                consent to perform a credit check.
                            </p>
                            <p>
                                By submitting this application, you confirm that
                                the applicant has consented to:
                            </p>
                            <ul>
                                <li style={{ marginTop: '15px' }}>
                                    - The collection, use and disclosure of
                                    personal information for the purposes of
                                    credit adjudication by Canlease and it's
                                    partners and to enable Canlease and its
                                    assigns to provide leasing services; and
                                </li>
                                <li style={{ marginTop: '15px' }}>
                                    - Canlease and its partners obtaining
                                    information relating to you, your company
                                    and guarantors from credit reporting
                                    agencies in connection with this application
                                </li>
                                <li style={{ marginTop: '15px' }}>
                                    - electronic communication and may opt-out
                                    at any time
                                </li>
                            </ul>
                        </div>
                        <input
                            type="checkbox"
                            id={'tos'}
                            ref={'creditCheckConsent'}
                            style={{
                                marginTop: '15px',
                                height: 'auto',
                                width: 'auto'
                            }}
                        />
                        <label for={'tos'}>
                            <span className="checkBox" />
                            <span style={{ color: 'red' }}>
                                I have read, and agree to the above statements.
                            </span>
                        </label>
                    </div>
                    <button className="left back-button" onClick={this.back}>
                        Back
                    </button>
                    <button className="right green">
                        {' '}
                        {Strings.CREDIT_BTN_NEXT}
                    </button>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/credit/components/CreditApplicationStep5.jsx